var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _c("nav-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header", class: _vm.headerClasses },
        [
          _c(
            "div",
            {
              staticClass: "header-buttons-container",
              class: { "header-buttons-container--undo": _vm.showUndo }
            },
            [
              _vm.authToken && !_vm.hideHeaderButtons
                ? _c("filter-button")
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "logo",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.visitLanding.apply(null, arguments)
                    }
                  }
                },
                [_c("logo")],
                1
              ),
              _vm._v(" "),
              _vm.authToken && !_vm.hideHeaderButtons
                ? _c("cart-icon")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("undo-pass-button", {
            on: {
              "show-changed": function(value) {
                return (_vm.showUndo = value)
              }
            }
          }),
          _vm._v(" "),
          _vm.showProgress ? _c("progress-bar") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12835cef", { render: render, staticRenderFns: staticRenderFns })
  }
}